import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Button, Snackbar, Box } from '@mui/material';
import { useState, useEffect } from 'react';
export const PwaInstallPrompt = () => {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    const [deferredPrompt, setDeferredPrompt] = useState(null);
    const [open, setOpen] = useState(false);
    const [installing, setInstalling] = useState(false);
    useEffect(() => {
        const handleBeforeInstallPrompt = (e) => {
            e.preventDefault();
            setDeferredPrompt(e);
            setOpen(true);
        };
        window.addEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        return () => {
            window.removeEventListener('beforeinstallprompt', handleBeforeInstallPrompt);
        };
    }, []);
    const handleInstallClick = () => {
        if (deferredPrompt) {
            setInstalling(true);
            deferredPrompt.prompt();
            deferredPrompt.userChoice.then((choiceResult) => {
                if (choiceResult.outcome === 'accepted') {
                    console.log('User accepted the A2HS prompt');
                }
                else {
                    console.log('User dismissed the A2HS prompt');
                }
                setDeferredPrompt(null);
                setOpen(false);
                setInstalling(false);
            });
        }
    };
    const handleClose = () => {
        setOpen(false);
    };
    return (_jsx("div", { children: _jsx(Snackbar, { open: open, color: "primary", anchorOrigin: { vertical: 'bottom', horizontal: 'center' }, message: "Install this app on your device for a better experience.", action: _jsxs(Box, Object.assign({ sx: {
                    display: 'flex',
                    justifyContent: 'flex-end',
                    alignItems: 'center',
                    gap: 1,
                } }, { children: [_jsx(Button, Object.assign({ variant: "contained", color: "secondary", onClick: handleInstallClick, disabled: installing }, { children: installing ? 'Installing...' : 'Install' })), _jsx(Button, Object.assign({ variant: "text", color: "secondary", onClick: handleClose, disabled: installing }, { children: "Dismiss" }))] })) }) }));
};
